import api from '@/services/api';

export default {
  getStaffCounter(params) {
    const t = `t=${new Date().getTime()}`;
    const q = [];
    q.push(t);

    Object.keys(params).forEach((key) => {
      q.push(`${key}=${params[key]}`);
    });

    const url = `/department/getStaffCounter?${q.join('&')}`;
    return new Promise((resolve) => {
      api.get(url).then((response) => {
        resolve(response);
      });
    });
  },
};
